import {
  B_02,
  BANNER_DEFAULTS,
  hideB02Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B02_PLASMIC_PROPS = {
  sectionHeading: {
    type: "string",
    defaultValue: "Finishes That Speak for Themselves.",
    description: "Section heading text (B02 only)",
    hidden: hideB02Props,
  },
  b02Slides: {
    type: "array",
    itemType: {
      type: "object",
      fields: {
        image: {
          type: "imageUrl",
        },
        imageAlt: {
          type: "string",
        },
        heading: {
          type: "string",
        },
        description: {
          type: "string",
        },
      },
    },
    defaultValue: BANNER_DEFAULTS[B_02].slides,
    description: "Slides array (B02 only)",
    hidden: hideB02Props,
  },
};
